var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMudahMendapatkanKonsumen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104,
    height: 128.718,
    viewBox: "0 0 104 128.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.84,
    y1: 0.13,
    x2: 0.14,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0783d",
    stopOpacity: 0.482
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-692 -907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(692 907)",
    opacity: 0.266,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.472 678.404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.529 280.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.761,6.671A1.275,1.275,0,0,0,15.9,8.8c1.116,1.168,2.244,2.346,3.364,3.517a1.281,1.281,0,1,0,1.851-1.768l-1.246-1.3h3.412a1.281,1.281,0,1,0,0-2.561C21.129,6.675,18.889,6.693,16.761,6.671Zm12.2.01a1.281,1.281,0,0,0,0,2.561h3.062a1.281,1.281,0,1,0,0-2.561ZM24.67,14.417a1.308,1.308,0,0,0-.923,2.141l3.327,3.459a1.281,1.281,0,1,0,1.853-1.766L25.6,14.782A1.216,1.216,0,0,0,24.67,14.417Zm7.351,7.119a1.276,1.276,0,0,0-.8,2.141l3.327,3.469a1.284,1.284,0,1,0,1.853-1.776l-3.329-3.462A1.478,1.478,0,0,0,32.021,21.536Zm7.316,8.412a1.28,1.28,0,0,0-.908,2.181l4.2,4.575H39.855a1.282,1.282,0,1,0,0,2.564h5.683a1.281,1.281,0,0,0,.945-2.146L40.32,30.4A1.413,1.413,0,0,0,39.337,29.947ZM8.364,36.7a1.282,1.282,0,1,0,0,2.564h4.755a1.282,1.282,0,1,0,0-2.564Zm10.283,0a1.282,1.282,0,0,0,0,2.564h4.8a1.282,1.282,0,0,0,0-2.564Zm11.363,0a1.282,1.282,0,1,0,0,2.564h4.8a1.282,1.282,0,0,0,0-2.564Z",
    transform: "translate(24.584 23.01)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.784,289.422H29.835a3.827,3.827,0,0,1,3.836,3.836v26.393a3.828,3.828,0,0,1-3.836,3.836H4.784a3.828,3.828,0,0,1-3.836-3.836V293.258a3.828,3.828,0,0,1,3.836-3.836Z",
    transform: "translate(-0.948 -246.768)",
    fill: "#ffca3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.445,289.422V299.6a1.8,1.8,0,0,0,1.8,1.8h4.985a1.8,1.8,0,0,0,1.8-1.8V289.422Z",
    transform: "translate(8.622 -246.768)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.172 59.146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.249,292.835a1.28,1.28,0,0,0,.123,2.558H8.006a1.279,1.279,0,0,0,0-2.558Z",
    transform: "translate(-1.978 -292.835)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,294a1.279,1.279,0,1,0,0,2.558h9.269a1.279,1.279,0,1,0,0-2.558Z",
    transform: "translate(-2.018 -288.358)",
    fill: "#ff9700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.661,295.594a2.558,2.558,0,0,0-1.925,4.238H25.416A3.813,3.813,0,0,0,29.252,296v-.4Z",
    transform: "translate(-1.7 -282.26)",
    fill: "#ff9700"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.963,292.663c0,6.664-9.728,19.106-12.067,19.106s-12.067-12.442-12.067-19.106a12.067,12.067,0,1,1,24.134,0Z",
    transform: "translate(40.755 -280.596)",
    fill: "#dad4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.52,286.185a4.012,4.012,0,1,1-4.012-4.012,4.012,4.012,0,0,1,4.012,4.012Z",
    transform: "translate(47.143 -274.55)",
    fill: "#eae8e8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMudahMendapatkanKonsumen);
export default __webpack_public_path__ + "static/media/mudah-mendapatkan-konsumen.d0297eadd0c8ef00fa39c362eb8a62b5.svg";
export { ForwardRef as ReactComponent };